<div *ngVar="{
         isInit: wrapper === undefined && isAnalysisProvided === undefined,
         isEmptyState: isAnalysisProvided === false,
         isLoading: wrapper === undefined && isAnalysisProvided,
         isDataFetched: !!wrapper
         } as state"
     [attr.data-qa]="'kpi-portfolio-analysis-main'"
     class="main height-77vh aligned-column-container column-gap-0p5">
  <div class="end-row-container">
    <div class="centered-row-container row-gap-0p5">
        <span
          data-qa="kpi-portfolio-analysis-data-frame-show-text"
          class="font-4 black-10">Show</span>
      <app-selector
        data-qa="kpi-portfolio-analysis-data-frame-selector"
        class="width-10"
        [disabled]="!state.isDataFetched"
        [selectedItem]="timeFrameHelper.reversedMap.get(selected.timeFrame)"
        [textClass]="'caption-2 black-10'"
        [outerClass]="'control-shrinked-container'"
        [data]="timeFrameHelper.map"
        (itemEmitter)="selectTimeFrame($event)"
      />
      @if (isAdmin) {
        <app-button
          @skeletonAnimation
          class="settings-button"
          [attr.data-qa]="'kpi-portfolio-analysis-settings'"
          [additionalClasses]="'width-6'"
          [type]="'accent'"
          [size]="'xsmall'"
          [showIcon]="'left'"
          [iconName]="'settings.svg'"
          [disabled]="state.isInit || state.isLoading"
          (buttonClick)="show.crudModal = true">
          Settings
        </app-button>
      }
    </div>
  </div>
  <div class="vertical-container-simple column-gap-1 height-95pcnt">
    <div class="overlap-children width-100pcnt height-100pcnt">
      <!--Empty state-->
      <app-empty-state-standard
        *ngIf="state.isEmptyState"
        [attr.data-qa]="'kpi-portfolio-analysis-empty-state'"
        [isAdmin]="isAdmin"
        [heading]="'No selected metrics yet'"
        [buttonText]="'Add metric'"
        [buttonIconName]="'plus.svg'"
        (buttonClick)="show.crudModal = true">
      </app-empty-state-standard>
      <!--Skeleton-->
      <div *ngIf="state.isLoading" @skeletonAnimation class="table-fms">
        <table>
          <thead>
          <!--First row-->
          <tr class="bg-white-12 height-1p5625"></tr>
          <!--Second row-->
          <tr>
            <th class="fix-w-2"></th>
            <th class="fix-w-10p25">Company</th>
            <th class="blank-space no-hover white-bg"></th>
            @for (i of [].constructor(9); track i) {
              <th class="fix-w-10p25">
                <div class="start-column-container">
                  <span class="bold500">Metric Group</span>
                  <span class="bold400">Metric</span>
                </div>
              </th>
            }
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let i of [].constructor(8)"
              app-table-empty-state
              class="animation-wrapper"
              [tdAmount]="12"
              [blankSpaceIndices]="[2,12]">
          </tr>
          </tbody>
        </table>
      </div>
      <!--Real data-->
      <div *ngIf="state.isDataFetched"
           @skeletonAnimation
           class="table-fms">
        <table
          [attr.data-qa]="'kpi-portfolio-analysis-table'">
          <thead>
          <!--First row-->
          <tr class="height-1p5625" [attr.data-qa]="'kpi-portfolio-analysis-table-first-header'">
            <th class="sticky-group col-three-dots bg-white-12"></th>
            <th class="sticky-group col-company-name bg-white-12"></th>
            <th class="sticky-group blank-space no-hover bg-white-12"></th>
            <th *ngFor="let header of dynamicHeaders; let i = index"
                [class.bg-main-8]="header.role === MetricDataRole.ACTUAL"
                [class.bg-orange-10]="header.role === MetricDataRole.BUDGET"
                class="fix-w-10p25 white-12">
              <div class="centered-row-container justify-start items-start gap-1">
                <span
                  *ngVar="'metric-data-role-header-' + i as id"
                  [id]="id"
                  (mouseenter)="showMetricRoleTooltip(header, id)"
                  (mouseleave)="show.tooltipMetricRole = null"
                >{{ header.role === MetricDataRole.ACTUAL ? 'A' : 'B' }}</span>
                <span>•</span>
                <span class="caption-2 bold600 upper-case">{{ header.period.expected | date: "MMM, y" }}</span>
              </div>
            </th>
            <th class="bg-white-12"></th>
          </tr>
          <!--Second row-->
          <tr [attr.data-qa]="'kpi-portfolio-analysis-table-second-header'">
            <th class="sticky-group col-three-dots">
              <app-three-dots-menu [matMenuTriggerFor]="menu"/>
              <mat-menu #menu="matMenu">
                <ul class="list">
                  <app-drop-down-item
                    data-qa="export-to-excel-table"
                    class="width-100pcnt"
                    [text]="'Export table' + (!allMetricGroups ? ' Loading...' : '')"
                    [iconNameAndStyling]="'excel.svg'"
                    [disabled]="!allMetricGroups"
                    (click)="exportTable()">
                  </app-drop-down-item>
                  <app-drop-down-item
                    data-qa="export-to-excel-actual"
                    class="width-100pcnt"
                    [text]="'Export all companies: Actual' + (!allMetricGroups ? ' Loading...' : '')"
                    [iconNameAndStyling]="'excel.svg'"
                    [disabled]="!allMetricGroups"
                    (click)="exportExcel('Actual')">
                  </app-drop-down-item>
                </ul>
                <ul class="list">
                  <app-drop-down-item
                    data-qa="export-to-excel-budget"
                    class="width-100pcnt"
                    [text]="'Export all companies: Budget' + (!allMetricGroups ? ' Loading...' : '')"
                    [iconNameAndStyling]="'excel.svg'"
                    [disabled]="!allMetricGroups"
                    (click)="exportExcel('Budget')">
                  </app-drop-down-item>
                </ul>
              </mat-menu>
            </th>
            <th class="sticky-group col-company-name">
              <div class="start-row-container row-gap-0p5">
                <span
                  appSort
                  [arr]="[wrapper.tracked.companies, wrapper.untracked.companies]"
                  [keySelector]="sort.byCompany">Company</span>
              </div>
            </th>
            <th class="sticky-group blank-space no-hover"></th>
            <th *ngFor="let header of dynamicHeaders; index as i"
                appSort
                [attr.data-qa]="'kpi-portfolio-analysis-table-second-header-dynamic-'+i"
                [arr]="[wrapper.tracked.companies, wrapper.untracked.companies]"
                [keySelector]="sort.byMetric[i]"
                (mouseenter)="setKpiShowIconSettings(null, null, i)"
                class="fix-w-10p25">
              <div class="flex flex-row w-full align-items-center justify-between">
                <div
                  *ngVar="'metric-name-header-' + header.metricName + '-' + header.metricGroupName as id"
                  [attr.id]="id"
                  [attr.data-qa]="id"
                  class="start-column-container"
                  (mouseenter)="showMetricHeaderTooltip(header, id)"
                  (mouseleave)="show.tooltipHeaderMetricName = null"
                >
                  <span class="bold500">{{ header.metricName | linkShort : MAX_METRIC_NAME_LENGTH }}</span>
                  <span
                    class="bold400 black-10">{{ header.metricGroupName | linkShort : MAX_METRIC_NAME_LENGTH }}</span>
                </div>
                <app-all-icons
                  *ngIf="header.data.metricDataType === MetricDataType.NUMBER && show.chartIcon.headerIndex === i"
                  [attr.data-qa]="'kpi-total-analysis-chart-' + header.metricGroupName + '-' + header.metricName"
                  class="hover-main-8 black-7"
                  [iconNameAndStyling]="'chart.svg'"
                  (click)="openChartModal(header.metricGroupName, header.metricName, header.role)">
                </app-all-icons>
              </div>
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody [attr.data-qa]="'kpi-portfolio-analysis-table-body'">
          <tr>
            <td class="sticky-group col-three-dots"
                (click)="show.grouping.tracked.isShown = !show.grouping.tracked.isShown">
              <app-table-group-icon [opened]="show.grouping.tracked.isShown"/>
            </td>
            <td class="sticky-group col-company-name">
              <div class="start-row-container row-gap-0p5">
                <span class="bold500">Tracked</span>
                <span data-qa="tracked-amount-badge" class="caption-2 bold500 bg-black-4 br-0p5 padding-0p15625-0p3125">
                  {{ show.grouping.tracked.amount }}
                </span>
              </div>
            </td>
            <td colspan="100%"></td>
          </tr>
            @if (show.grouping.tracked.isShown) {
              <tr *ngFor="let company of wrapper.tracked.companies; index as i"
                  [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-'+i">
                <td class="sticky-group col-three-dots">
                  <app-three-dots-menu [matMenuTriggerFor]="menu"/>
                  <mat-menu #menu="matMenu">
                    <ul class="list">
                      <app-drop-down-item
                        [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-track-company-' + i"
                        class="width-100pcnt"
                        [text]="'Set not tracked'"
                        [iconNameAndStyling]="'crossed-eye.svg'"
                        (click)="updateTrackStatus(company.company.uuid, false)">
                      </app-drop-down-item>
                    </ul>
                  </mat-menu>
                </td>
                <td class="sticky-group col-company-name">
                  <span
                    [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-'+i+'-company'"
                    class="bold500 company-name light-bold"
                    (click)="goToCompanyMetrics(company.company)">
                    {{ company.company.name }}
                  </span>
                </td>
                <td class="sticky-group blank-space"></td>
                <ng-container *ngFor="let entry of company.entries; index as j">
                  <td
                    *ngVar="company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName + '-' + entry.period.expected + '-' + entry.role as id"
                    class="fix-w-10p25"
                    [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-cell' + id"
                    (mouseenter)="setKpiShowIconSettings(i, j, j)">
                    <div class="flex flex-row justify-between items-center w-full h-full show-on-hover-container">
                      @if (entry.data.metricDataType === MetricDataType.DOCUMENT
                        ? (entry.data.rawValue | checkNewline: true)
                        : entry.data.rawValue && entry.data.rawValue !== '0' && entry.data.rawValue !== '0.0') {
                        @if (entry.data.metricDataType === MetricDataType.DOCUMENT) {
                          <div
                            *ngVar="company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName + '-' + entry.period.expected + '-' + entry.role as id"
                            [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-rowValue-' + id"
                            class="flex flex-col items-start kpi-portfolio-analysis-document-metric clickable main-8"
                            [id]="'tracked-modal-metric-data-' + i + j"
                            (click)="showDocuments(entry, company.company.uuid, true)"
                            (mouseenter)="activateDocumentsToolTip('tracked-modal-metric-data-' + i + j, entry.data.rawValue, entry)"
                            (mouseleave)="hideDocumentsToolTip()">
                            <span>
                              <div class="flex flex-grow items-center gap-0.1562 w-full h-full">
                                <app-all-icons [iconNameAndStyling]="'documents-stack.svg;icon-size-0p9375'"/>
                                <span class="bold500 !text-[0.625rem]"> {{ entry.data.rawValue | kpiDocumentsToCount }}</span>
                                <app-all-icons [iconNameAndStyling]="'expand-arrow-diagonal.svg;icon-size-0p9375;icon-expand-arrow'"/>
                              </div>
                            </span>
                            <span *ngIf="!entry.period.isMatchingPeriod" class="caption-3 bold500 black-9">
                              {{ entry.period.provided | date: 'MMM, y' }}
                            </span>
                          </div>
                        } @else {
                          <div class="flex flex-col items-start"
                               *ngVar="company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName + '-' + entry.period.expected + '-' + entry.role as id">
                            <span [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-rowValue-' + id"
                                  class="bold500">
                            @switch (entry.data.metricDataType) {
                              @case (MetricDataType.NUMBER) {
                                {{ (entry.data.sign === MetricSign.NEGATIVE ? -1 : 1) * Number(entry.data.rawValue) | number:'1.0-0' | negativeValueToBraces }}
                              }
                              @case (MetricDataType.PERCENT) {
                                {{ (entry.data.sign === MetricSign.NEGATIVE ? -1 : 1) * Number(entry.data.rawValue) | number:'1.2-2' | negativeValueToBraces }}%
                              }
                              @case (MetricDataType.DATE) {
                                <span>{{ entry.data.rawValue }}</span>
                              }
                              @case (MetricDataType.STRING) {
                                <span>{{ entry.data.rawValue | linkShort: 40 }}</span>
                              }
                            }
                            </span>
                            <span
                              *ngIf="!entry.period.isMatchingPeriod"
                              #tooltip
                              class="caption-3 bold500 black-9"
                              [id]="id"
                              [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-tracked-is-period-provided-' + id"
                              (mouseenter)="showTooltipForMissingPeriods(tooltip.id, entry)"
                              (mouseleave)="showTooltipForMissingPeriods(null, null)">
                              {{ entry.period.provided | date: 'MMM, y' }}
                            </span>
                          </div>
                        }
                        @if (entry.data.metricDataType === MetricDataType.NUMBER && show.chartIcon.trIndex === i) {
                          <app-all-icons
                            [attr.data-qa]="'kpi-company-analysis-chart-' + company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName"
                            class="clickable hover-main-8 black-7"
                            [iconNameAndStyling]="'chart.svg'"
                            (click)="openChartModal(entry.metricGroupName, entry.metricName, entry.role, company.company.uuid, company.company.name)">
                          </app-all-icons>
                        } @else if (entry.data.metricDataType === MetricDataType.STRING) {
                          <app-all-icons
                            [id]="'tracked-modal-metric-data-' + i + j"
                            [attr.data-qa]="'kpi-portfolio-analysis-text-icon-' + i + '-' + j"
                            class="show-on-hover-object"
                            [iconNameAndStyling]="'info-empty.svg;icon-size-1p25 black-9'"
                            (mouseenter)="showToolTipForStringMetric('tracked-modal-metric-data-' + i + j, entry.data.rawValue)"
                            (mouseleave)="show.tooltipForStringMetrics.show = false"
                          />
                        }
                      }
                    </div>
                  </td>
                </ng-container>
                <td></td>
              </tr>
            }
          <tr>
            <td class="sticky-group col-three-dots"
                (click)="show.grouping.untracked.isShown = !show.grouping.untracked.isShown">
              <app-table-group-icon [opened]="show.grouping.untracked.isShown"/>
            </td>
            <td class="sticky-group col-company-name">
              <div class="start-row-container row-gap-0p5">
                <span class="bold500">Not tracked</span>
                <span data-qa="untracked-amount-badge"
                      class="caption-2 bold500 bg-black-4 br-0p5 padding-0p15625-0p3125">
                  {{ show.grouping.untracked.amount }}
                </span>
              </div>
            </td>
            <td colspan="100%"></td>
          </tr>
            @if (show.grouping.untracked.isShown) {
              <tr *ngFor="let company of wrapper.untracked.companies; index as i"
                  [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untracked-'+i">
                <td class="sticky-group col-three-dots">
                  <app-three-dots-menu [matMenuTriggerFor]="menu"/>
                  <mat-menu #menu="matMenu">
                    <ul class="list">
                      <app-drop-down-item
                        [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untrack-company-' + company.company.name"
                        class="width-100pcnt"
                        [text]="'Set tracked'"
                        [iconNameAndStyling]="'eye.svg'"
                        (click)="updateTrackStatus(company.company.uuid, true)">
                      </app-drop-down-item>
                    </ul>
                  </mat-menu>
                </td>
                <td class="sticky-group col-company-name">
                  <span
                    [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untracked-'+i+'-company'"
                    class="bold500 company-name light-bold"
                    (click)="goToCompanyMetrics(company.company)">
                    {{ company.company.name }}
                  </span>
                </td>
                <td class="sticky-group blank-space"></td>
                <ng-container *ngFor="let entry of company.entries; index as j">
                  <td (mouseenter)="setKpiShowIconSettings(i + wrapper.tracked.companies.length, j, j)">
                    <div class="flex justify-between items-center w-full h-full show-on-hover-container">
                      <!-- boxFolderID and files separated by \n.-->
                      @if (entry.data.metricDataType === MetricDataType.DOCUMENT && (entry.data.rawValue | checkNewline: true)) {
                        <div *ngVar="company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName + '-' + entry.period.expected + '-' + entry.role as id"
                             [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untracked-rowValue-' + id"
                             class="flex flex-col items-start kpi-portfolio-analysis-document-metric clickable main-8"
                             [id]="'kpi-portfolio-analysis-table-body-row-untracked-'+i+'-rawValue-'+j"
                             (click)="showDocuments(entry, company.company.uuid, false)"
                             (mouseenter)="activateDocumentsToolTip('kpi-portfolio-analysis-table-body-row-untracked-'+i+'-rawValue-'+j, entry.data.rawValue, entry)"
                             (mouseleave)="hideDocumentsToolTip()">
                            <span class="bold500">
                              <div class="flex flex-grow items-center gap-0.1562 w-full h-full">
                                <app-all-icons [iconNameAndStyling]="'documents-stack.svg;icon-size-0p9375'"/>
                                <span class="bold500 !text-[0.625rem]"> {{ entry.data.rawValue | kpiDocumentsToCount }}</span>
                                <app-all-icons [iconNameAndStyling]="'expand-arrow-diagonal.svg;icon-size-0p9375;icon-expand-arrow'"/>
                              </div>
                            </span>
                          <span *ngIf="!entry.period.isMatchingPeriod" class="caption-3 bold500 black-9">
                              {{ entry.period.provided | date: 'MMM, y' }}
                            </span>
                        </div>
                      } @else if (entry.data.rawValue && entry.data.rawValue !== '0' && entry.data.rawValue !== '0.0') {
                        <div
                          *ngVar="company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName + '-' + entry.period.expected + '-' + entry.role as id"
                          class="start-column-container">
                            <span
                              [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untracked-rawValue-' + id"
                              class="bold500">
                                @switch (entry.data.metricDataType) {
                                  @case (MetricDataType.NUMBER) {
                                    {{ (entry.data.sign === MetricSign.NEGATIVE ? -1 : 1) * Number(entry.data.rawValue) | number:'1.0-0' | negativeValueToBraces }}
                                  }
                                  @case (MetricDataType.PERCENT) {
                                    {{ (entry.data.sign === MetricSign.NEGATIVE ? -1 : 1) * Number(entry.data.rawValue) | number:'1.2-2' | negativeValueToBraces }}%
                                  }
                                  @case (MetricDataType.DATE) {
                                    <span>{{ entry.data.rawValue }}</span>
                                  }
                                  @case (MetricDataType.STRING) {
                                    <span>{{ entry.data.rawValue | linkShort: 40 }}</span>
                                  }
                                }
                              </span>
                          <span
                            *ngIf="!entry.period.isMatchingPeriod"
                            #tooltip
                            class="caption-3 bold500 black-9"
                            [id]="id"
                            [attr.data-qa]="'kpi-portfolio-analysis-table-body-row-untracked-'+i+'-is-period-provided-' + id"
                            (mouseenter)="showTooltipForMissingPeriods(tooltip.id, entry)"
                            (mouseleave)="showTooltipForMissingPeriods(null, null)">
                                  {{ entry.period.provided | date: 'MMM, y' }}
                            </span>
                        </div>
                        @if (entry.data.metricDataType === MetricDataType.NUMBER && show.chartIcon.trIndex === i + wrapper.tracked.companies.length) {
                          <app-all-icons
                            [attr.data-qa]="'kpi-company-analysis-chart-' + company.company.name + '-' + entry.metricGroupName + '-' + entry.metricName"
                            class="clickable hover-main-8 black-7"
                            [iconNameAndStyling]="'chart.svg'"
                            (click)="openChartModal(entry.metricGroupName, entry.metricName, entry.role, company.company.uuid, company.company.name)">
                          </app-all-icons>
                        } @else if (entry.data.metricDataType === MetricDataType.STRING) {
                          <app-all-icons
                            [id]="'untracked-modal-metric-data-' + i + j"
                            [attr.data-qa]="'kpi-portfolio-analysis-text-icon-' + i + '-' + j"
                            class="show-on-hover-object"
                            [iconNameAndStyling]="'info-empty.svg;icon-size-1p25 black-9'"
                            (mouseenter)="showToolTipForStringMetric('untracked-modal-metric-data-' + i + j, entry.data.rawValue)"
                            (mouseleave)="show.tooltipForStringMetrics.show = false"
                          />
                        }
                      }
                    </div>
                  </td>
                </ng-container>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<app-kpi-portfolio-analysis-crud
  *ngIf="show.crudModal"
  [attr.data-qa]="'kpi-portfolio-analysis-crud'"
  (closeModal)="closeCrudModal($event)">
</app-kpi-portfolio-analysis-crud>
<app-kpi-portfolio-analysis-chart-wrapper
  *ngIf="show.chartModal"
  [attr.data-qa]="'kpi-portfolio-analysis-chart'"
  [setUp]="chartSetUp"
  (closeModal)="show.chartModal = false">
</app-kpi-portfolio-analysis-chart-wrapper>
<app-tooltip
  *ngIf="show.tooltipForMissingPeriods"
  [attr.data-qa]="'kpi-portfolio-analysis-tooltip'"
  [coordinates]="show.tooltipForMissingPeriods.tooltipCoordinates">
  <div class="start-column-container caption-2">
    <span>No data as of {{ (show.tooltipForMissingPeriods.expected | date: 'MMM, y') }}</span>
    <span>Latest data as of {{ (show.tooltipForMissingPeriods.provided | date: 'MMM, y') }}</span>
  </div>
</app-tooltip>

<app-tooltip
  *ngIf="show.tooltipForStringMetrics.show"
  [coordinates]="show.tooltipForStringMetrics.coordinates">
  <pre
    class="white-12 whitespace-pre-wrap break-words font-tooltip"
    [ngClass]="show.tooltipForStringMetrics.text.length < 11 ? 'width-7 centered-row-container' : 'width-25'"
    [innerHTML]="show.tooltipForStringMetrics.text">
  </pre>
</app-tooltip>

<app-tooltip
  *ngIf="show.tooltipHeaderMetricName"
  [coordinates]="show.tooltipHeaderMetricName.tooltipCoordinates"
  [text]="show.tooltipHeaderMetricName.tooltipText"
  [title]="show.tooltipHeaderMetricName.tooltipTitle"
/>

<app-tooltip
  *ngIf="show.tooltipMetricRole"
  [coordinates]="show.tooltipMetricRole.coordinates"
  [title]="show.tooltipMetricRole.title"
/>

<app-tooltip
  *ngIf="show.tooltipForDocuments.show"
  [coordinates]="show.tooltipForDocuments.coordinates"
  [freezeOnHover]="false">
  <div *ngFor="let file of show.tooltipForDocuments.selectedFiles"
       class="!text-[0.625rem] font-medium break-words whitespace-normal max-w-[30rem]">
    {{ file }}
  </div>
  <div class="start-column-container !text-[0.5rem] opacity-90">
    <span *ngIf="show.tooltipForDocuments.expectedPeriod">No data as of {{ (show.tooltipForDocuments.expectedPeriod | date: 'MMM, y') }}</span>
    <span *ngIf="show.tooltipForDocuments.providedPeriod">Latest data as of {{ (show.tooltipForDocuments.providedPeriod | date: 'MMM, y') }}</span>
    <span> Click to view and download </span>
  </div>
</app-tooltip>

@if (!!documentCrudWrapper.wrapper) {
  <app-kpi-modal-document-crud
    [isEditEnabled]="false"
    [isFromMetricSharedLinkPage]="false"
    [wrapper]="documentCrudWrapper.wrapper"
    (closeEmitter)="updateRowValueFromMetricDocumentAndClose($event)"/>
}

